<template>
    <div class="max-w-(--breakpoint-sm) flex flex-col gap-4">
        <page-header>Billing Details</page-header>

        <org-unit-billing-email
            :teamId="props.teamId"
            :orgUnitId="props.orgUnitId"
            :billingEmail="props.billing.billing_email"
            :isEditable="isEditable"
        />

        <org-unit-billing-info
            :teamId="props.teamId"
            :orgUnitId="props.orgUnitId"
            :billingInformation="{
                billing_company_legal_name: props.billing.billing_company_legal_name,
                billing_address: props.billing.billing_address,
                billing_address_line_2: props.billing.billing_address_line_2,
                billing_city: props.billing.billing_city,
                billing_state: props.billing.billing_state,
                billing_zip: props.billing.billing_zip,
                billing_country: props.billing.billing_country,
                billing_po_number: props.billing.billing_po_number,
            }"
            :isEditable="isEditable"
        />

        <org-unit-stripe-payment-method
            v-if="isEditable && stripeKey"
            :teamId="props.teamId"
            :orgUnitId="props.orgUnitId"
            :paymentMethod="{ card_brand: props.billing.card_brand, card_last_four: props.billing.card_last_four }"
            :stripeKey="stripeKey"
            :stripeApiVersion="stripeApiVersion"
        />
    </div>
</template>

<script setup>
import PageHeader from '~/components/general/PageHeader.vue';
import OrgUnitBillingEmail from '~/components/settings/billing/OrgUnitBillingEmail.vue';
import OrgUnitBillingInfo from '~/components/settings/billing/OrgUnitBillingInfo.vue';
import OrgUnitStripePaymentMethod from '~/components/settings/billing/OrgUnitStripePaymentMethod.vue';
import { computed } from 'vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
    billing: {
        type: Object,
        required: true,
    },
    isAdminOrOwner: {
        type: Boolean,
        default: false,
    },
});

const stripeKey = Spark.stripeKey;
const stripeApiVersion = Spark.stripeApiVersion;

const isEditable = computed(() => props.isAdminOrOwner && props.billing.is_billable);
</script>
